<div
  class="tag medium-type font-body-2 flex--inline flex--middle align-center ps-xsmall-x rounded-medium"
  [ngClass]="{
    'white-text':
      (theme() === TagTheme.ACTIVE || theme() === TagTheme.POPULAR || theme() === TagTheme.BLACK_FRIDAY) && !disabled(),
    'nordic-blue-900-text nordic-blue-25-bg': theme() === TagTheme.DEFAULT && !disabled(),
    'nordic-blue-900-bg': theme() === TagTheme.ACTIVE && !disabled(),
    'white-bg nordic-blue-900-text': theme() === TagTheme.WHITE && !disabled(),
    'birch-50-bg birch-600-text': theme() === TagTheme.SUSTAINABILITY && !disabled(),
    'heather-700-bg': theme() === TagTheme.POPULAR && !disabled(),
    'nordic-blue-900-text success-50-bg': theme() === TagTheme.SUCCESS && !disabled(),
    'nordic-blue-900-text alert-50-bg': theme() === TagTheme.WARNING && !disabled(),
    'nordic-blue-900-text error-50-bg': theme() === TagTheme.ALERT && !disabled(),
    'black-bg': theme() === TagTheme.BLACK_FRIDAY && !disabled(),
    'border-rounded-chip': roundingStyle() === TagRoundingStyle.CHIP,
    'grey-200-bg grey-600-text': disabled(),
  }"
>
  <ng-content />
</div>
